module.exports = __webpack_public_path__ + "static/media/information.f8134a1b.svg";